import * as React from "react";
import type { SVGProps } from "react";
import { Ref, forwardRef } from "react";
interface SVGRProps {
  title?: string;
  titleId?: string;
}
const SvgUser = (
  { title, titleId, ...props }: SVGProps<SVGSVGElement> & SVGRProps,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 24 24"
    width="1em"
    height="1em"
    ref={ref}
    aria-labelledby={titleId}
    {...props}
  >
    {title ? <title id={titleId}>{title}</title> : null}
    <path
      fill="#5B6770"
      fillRule="evenodd"
      d="M7.91 6.24c0-2.21 1.83-4 4.09-4s4.09 1.79 4.09 4-1.83 4-4.09 4-4.09-1.79-4.09-4ZM12 0C8.475 0 5.618 2.794 5.618 6.24S8.475 12.48 12 12.48c3.525 0 6.382-2.794 6.382-6.24S15.525 0 12 0ZM6.49 17.492a4.138 4.138 0 0 1 2.892-1.172h5.236c1.085 0 2.126.421 2.893 1.172a3.955 3.955 0 0 1 1.198 2.828v2.56c0 .619.513 1.12 1.146 1.12.632 0 1.145-.501 1.145-1.12v-2.56a6.17 6.17 0 0 0-1.87-4.412 6.456 6.456 0 0 0-4.512-1.828H9.382a6.456 6.456 0 0 0-4.513 1.828A6.17 6.17 0 0 0 3 20.32v2.56c0 .619.513 1.12 1.145 1.12.633 0 1.146-.501 1.146-1.12v-2.56c0-1.06.43-2.078 1.198-2.828Z"
      clipRule="evenodd"
    />
  </svg>
);
const ForwardRef = forwardRef(SvgUser);
export default ForwardRef;
